import React from 'react'
import { I18n } from 'react-redux-i18n'
import { Container, Button, Col, Row, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { MARKETING } from '../../../../constants'

const ModalTemplate = ({ isOpenModal, setIsOpenModal, textToCopy }) => {
  return (
    <Modal id={'modalTemplate'} isOpen={isOpenModal} centered={true} toggle={() => setIsOpenModal(!isOpenModal)} className='modal-copy' size={'xs'}>
      <ModalHeader>{I18n.t('templates_validation_title')}</ModalHeader>
      <ModalBody>
        <Row className={'seccionWrapper-1'}>
          <Col className={'seccion-1'}>
            <p>
              <span id='ojo'>{I18n.t('templates_validation_eye')}</span>{` ${I18n.t('templates_validation_legend')}:`}
            </p>
            <a href={MARKETING.urlsTwillo.templates} target={'blank'} className='link-twillo'>
              <span>{I18n.t('templates_validation_button_check1')}</span>
              <span>{I18n.t('templates_validation_button_check2')}</span>
              <img src='./img/icons/arrow-up-right.svg' alt='arrow' />
            </a>
          </Col>
        </Row>
        <Row className={'seccionWrapper-2'}>
          <Col>
            <h3>{`${I18n.t('templates_validation_remember')}:`}</h3>
            <p>
              {`${I18n.t('templates_validation_remember2')} `}<b>{`${I18n.t('templates_validation_remember3')} `}</b>{`${I18n.t('templates_validation_remember4')}`}
            </p>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Container>
          <Row noGutters>
            <Col className='text-left'>
              <Button color='primary' size={'sm'} onClick={() => setIsOpenModal(false)}>
                {I18n.t('dashboard_understand')}
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalFooter>
    </Modal>
  )
}

export default ModalTemplate
